import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { SubmitButton, Field, FormCadastro, GroupField, TimePicker, View } from '@components';
import { getHorarioFuncionamento, putHorarioFuncionamento } from '@ducks/conectoresHorarioFuncionamento';
import { formatTimeS, Notification } from '@utils';

export default function Cadastro() {
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { id } = useParams();

  const horarioFuncionamento = useSelector(({ conectoresHorarioFuncionamento }) =>
    conectoresHorarioFuncionamento.get('horarioFuncionamento')
  );
  const successHorarioFuncionamento = useSelector(({ conectoresHorarioFuncionamento }) =>
    conectoresHorarioFuncionamento.get('successHorarioFuncionamento')
  );
  const successPutHorarioFuncionamento = useSelector(({ conectoresHorarioFuncionamento }) =>
    conectoresHorarioFuncionamento.get('successPutHorarioFuncionamento')
  );

  useEffect(() => {
    if (successPutHorarioFuncionamento) {
      Notification.success('Horários alterados');
    }
  }, [successPutHorarioFuncionamento]);

  useEffect(() => {
    dispatch(getHorarioFuncionamento(id));
  }, [id]);

  useEffect(() => {
    if (horarioFuncionamento) {
      form.setFieldsValue(horarioFuncionamento);
    }
  }, [successHorarioFuncionamento]);

  const handleSubmit = (data) => {
    let dataToUpdate = { idConfiguracao: id };

    for (let horario in data) {
      const index = horario.replace('horario', '');
      dataToUpdate[`hrInicio${index}`] = formatTimeS(data[horario][0]);
      dataToUpdate[`hrFim${index}`] = formatTimeS(data[horario][1]);
    }

    dispatch(putHorarioFuncionamento(dataToUpdate));
  };

  return (
    <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
      <View>
        <strong>Horários de funcionamento</strong>
      </View>

      <GroupField>
        <Field label='Domingo' name='horario0' rules={[{ required: true, message: 'Informe o horário de domingo' }]}>
          <TimePicker.RangePicker format='HH:mm:ss' autoFocus />
        </Field>
      </GroupField>
      <GroupField>
        <Field label='Segunda-Feira' name='horario1' rules={[{ required: true, message: 'Informe o horário de segunda-feira' }]}>
          <TimePicker.RangePicker format='HH:mm:ss' />
        </Field>
      </GroupField>
      <GroupField>
        <Field label='Terça-Feira' name='horario2' rules={[{ required: true, message: 'Informe o horário de terça-feira' }]}>
          <TimePicker.RangePicker format='HH:mm:ss' />
        </Field>
      </GroupField>
      <GroupField>
        <Field label='Quarta-Feira' name='horario3' rules={[{ required: true, message: 'Informe o horário de quarta-feira' }]}>
          <TimePicker.RangePicker format='HH:mm:ss' />
        </Field>
      </GroupField>
      <GroupField>
        <Field label='Quinta-Feira' name='horario4' rules={[{ required: true, message: 'Informe o horário de quinta-feira' }]}>
          <TimePicker.RangePicker format='HH:mm:ss' />
        </Field>
      </GroupField>
      <GroupField>
        <Field label='Sexta-Feira' name='horario5' rules={[{ required: true, message: 'Informe o horário de sexta-feira' }]}>
          <TimePicker.RangePicker format='HH:mm:ss' />
        </Field>
      </GroupField>
      <GroupField>
        <Field label='Sábado' name='horario6' rules={[{ required: true, message: 'Informe o horário de sábado' }]}>
          <TimePicker.RangePicker format='HH:mm:ss' />
        </Field>
      </GroupField>

      <SubmitButton type='success' htmlType='submit' block>
        Salvar
      </SubmitButton>
    </FormCadastro>
  );
}
